import { render, staticRenderFns } from "./AdvancedInfo.vue?vue&type=template&id=2f22a609&"
import script from "./AdvancedInfo.vue?vue&type=script&lang=js&"
export * from "./AdvancedInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports